module.exports = __webpack_public_path__ + "assets/fonts/Roboto-Light.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/roboto/Roboto-Light.woff2
// module id = 686
// module chunks = 0